import React, { useState, useRef } from "react";
import {
    TextField,
    Popper,
    Paper,
    Checkbox,
    ListItemText,
    MenuItem,
    ClickAwayListener,
    Box,
    InputAdornment,
    Typography,
} from "@mui/material";
import { CustomTextInput } from "../../../../components/commonComponents/TextInputs/style";
import { generateRandomNumber } from "../../../../api_calls/utils";
import { StyledCheckbox } from "../../../../components/commonComponents/StyledComponents/styled";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function AddressSearchFilter({
    label,
    defaultVal,
    elemId,
    options,
    onChangeCall,
    fieldError,
    enableFullWidth,
}) {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selected, setSelected] = useState([]);
    const [search, setSearch] = useState("");
    const inputRef = useRef();

    const open = Boolean(anchorEl);

    const handleInputClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const toggleSelection = (option) => {
        setSelected((prev) => {
            const newSelected = prev.some(opt => opt.value === option.value)
                ? prev.filter((item) => item.value !== option.value)
                : [...prev, option]
            onChangeCall(newSelected);
            return newSelected;
        });
    };

    const filteredOptions = options.filter((option) =>
        option.label.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <Box sx={{ width: "600px" }}>
            <ClickAwayListener onClickAway={handleClose}>
                <div>
                    <CustomTextInput
                        autoFocus={false}
                        autoComplete="off"
                        id={elemId + "_cutomTextForDropdown"}
                        fullWidth={enableFullWidth}
                        sx={enableFullWidth ? { maxWidth: "100%" } : { maxWidth: "220px", width: "100%" }}
                        label={label}
                        variant="standard"
                        error={fieldError !== "" ? true : false}
                        helperText={fieldError !== "" ? fieldError : ""}
                        inputRef={inputRef}
                        onClick={handleInputClick}
                        onChange={(e) => {
                            setSearch(e.target.value);
                        }}
                        value={search}
                        InputProps={{
                            startAdornment: selected.length > 0 && (
                                <InputAdornment position="start">
                                    {`${selected.length} selected`}
                                </InputAdornment>
                            ),
                        }}
                    />
                    <Popper
                        open={open}
                        anchorEl={anchorEl}
                        placement="bottom-start"
                        style={{ zIndex: 1300 }}
                    >
                        <Paper
                            sx={{
                                width: 300,
                                maxHeight: 300,
                                overflowY: "scroll",
                            }}
                        >
                            {filteredOptions.length > 0 ? (
                                filteredOptions.map((option) => (
                                    <MenuItem
                                        key={option.value + "_searchOpt" + generateRandomNumber(3)}
                                        onClick={() => toggleSelection(option)}
                                    >
                                        <StyledCheckbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected.some(opt => opt.value === option.value)}
                                        />
                                        <Typography variant="body2" className="selectorOptions">{option.label}</Typography>

                                    </MenuItem>
                                ))
                            ) : (
                                <MenuItem disabled>No results</MenuItem>
                            )}
                        </Paper>
                    </Popper>
                </div>
            </ClickAwayListener>
        </Box>
    );
}
